(function ($) {
    'use strict';

    $(function () {

        $('section.products_list .products-list-swiper').each(function () {
            var el = this;
            var section = el.closest('section.products_list');
            var prevEl = section ? section.querySelector('.products-list-slider-arrow-prev') : null;
            var nextEl = section ? section.querySelector('.products-list-slider-arrow-next') : null;

            if (el.dataset.swiperInitialized === '1') {
                return;
            }

            el.dataset.swiperInitialized = '1';

            new Swiper(el, {
                slidesPerView: 'auto',
                spaceBetween: 24,
                speed: 600,
                watchOverflow: true,
                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl,
                },
            });
        });
    });
})(jQuery);
